export default import.meta.ROLLUP_FILE_URL_4Y0WjtVQeAXCD2QyP2kmfg